import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export const query = graphql(`
    query AppTaskQuery($id: ID!) {
        task(id:$id) {
            id
            skipDescriptionPage
            type
            discriminant
            shortTitle
            objectives
            inspiration {
                id
                mediaType
                src
            }
            title
            icon
            miles
            timeEstimate
            deadline
            media {
                id
                mediaType
                src
                name
                logo
            }
            shareAnswers
            shareAnswersAnonymously
            finished {
                id
                firstName
                lastName
                profilePicSrc
            }
            doInGroup
            taskGroup {
                id
                number
                name
                members {
                    id
                    firstName
                    lastName
                    profilePicSrc
                }
            }
            requireApproval
            feedbackTask {
                id
                shortTitle
            }
            taskVariants {
                id
                variantType
                variantTitle
                description
                hoursQuestions
                playerAiInstructions
                showTaskAiAssist
                taskQuestions {
                    id
                    answerType
                    questionContent
                    quizId
                    pollId
                    surveyGizmoUrl
                    requireAllCheckmarks
                    checkboxOptions {
                        id
                        content
                    }
                    taskLikertStatements {
                        id
                        statement
                        leftLabel
                        rightLabel
                    }
                    impactTracker {
                        id
                        impactLikertStatements {
                            id
                            statement
                            leftLabel
                            rightLabel
                        }
                    }
                    selectInImageMedia {
                        id
                        mediaType
                        src
                        name
                        logo
                    }
                }
                eventStart
                eventEnd
                incompleteAnswers {
                    id
                    questionContent
                    part
                    answerContent
                }
                suggestedQuestions {
                    id
                    nr
                    type
                    content
                    leftLabel
                    rightLabel
                }
                allowAddQuestions
                allowAccessCollectedFeedback
                allowTranslateCollectedFeedback
                anonymousCollectedFeedback
                collectFeedbackTitle
                collectFeedbackDescription
                pulseSuggestedQuestions {
                    id
                    locale
                    content
                }
            }
            learningPathItem {
                id
                miles
                earnedMiles
                tasks {
                    id
                    locked
                    icon
                    shortTitle
                    miles
                    deadline
                    url
                    doInGroup
                    shareAnswers
                    taskVariants {
                        id
                        variantType
                    }
                    submittedTask {
                        id
                        url
                        status
                    }
                }
                pathInPath {
                    id
                    icon
                    url
                    showGroup
                }
                taskChoice {
                    id
                    icon
                    url
                    name
                    complete
                }
                learningPath {
                    id
                    pathname
                }
            }
            submittedTask {
                id
                discriminant
                shortTitle
                objectives
                inspiration {
                    id
                    mediaType
                    src
                }
                title
                icon
                miles
                timeEstimate
                media {
                    id
                    mediaType
                    src
                    name
                    logo
                }
                shareAnswers
                shareAnswersAnonymously
                doInGroup
                requireApproval
                status
                people {
                    id
                    firstName
                    lastName
                    profilePicSrc
                }
                submittedTaskVariant {
                    id
                    variantType
                    variantTitle
                    description
                    hoursQuestions
                    playerAiInstructions
                    showTaskAiAssist
                    taskQuestions {
                        id
                        answerType
                        questionContent
                        quizId
                        pollId
                        surveyGizmoUrl
                        requireAllCheckmarks
                        selectInImageMedia {
                            id
                            mediaType
                            src
                            name
                            logo
                        }
                        checkboxOptions {
                            id
                            content
                        }
                        taskLikertStatements {
                            id
                            statement
                            leftLabel
                            rightLabel
                        }
                        impactTracker {
                            id
                            impactLikertStatements {
                                id
                                statement
                                leftLabel
                                rightLabel
                            }
                        }
                    }
                    eventStart
                    eventEnd
                    incompleteAnswers {
                        id
                        questionContent
                        part
                        answerContent
                    }
                    suggestedQuestions {
                        id
                        nr
                        type
                        content
                        leftLabel
                        rightLabel
                    }
                    allowAddQuestions
                    allowAccessCollectedFeedback
                    allowTranslateCollectedFeedback
                    anonymousCollectedFeedback
                    collectFeedbackTitle
                    collectFeedbackDescription
                    pulseSuggestedQuestions {
                        id
                        locale
                        content
                    }
                    teamScan {
                        id
                        status
                        myLink
                    }
                    pulse {
                        id
                        question1
                        question2
                        link
                        pulseAnswers {
                            id
                            answer1
                            answer2
                        }
                    }
                    taskAiThread {
                        id
                        aiThreadItems {
                            id
                            type
                            role
                            content
                        }
                    }
                }
                collectFeedback {
                    id
                    link
                    sendNotification
                    collectFeedbackAnswerSets {
                        id
                        firstName
                        lastName
                        submitted
                        collectFeedbackAnswers {
                            id
                            nr
                            type
                            question
                            translation
                            leftLabel
                            rightLabel
                            leftTranslation
                            rightTranslation
                            textAnswer
                            likertAnswer
                        }
                    }
                }
                taskApprovals {
                    id
                    status
                    membership {
                        id
                        person {
                            id
                        }
                    }
                }
                thread {
                    id
                    type
                    subtype
                    contentFormat
                    content
                    scaleScore {
                        earnedScore
                        possibleScore
                    }
                    person {
                        id
                        firstName
                        lastName
                        profilePicSrc
                    }
                    taskAnswers {
                        id
                        answerType
                        questionContent
                        answerContent
                        checkboxAnswers {
                            id
                            content
                            checked
                        }
                        taskLikertAnswers {
                            id
                            statement
                            leftLabel
                            rightLabel
                            value
                        }
                        showPollResults
                        quizAnswerSet {
                            id
                            results
                            answers {
                                id
                                answer
                                answeredQuestion {
                                    id
                                    number
                                    levelNumber
                                    description
                                    correctAnswer
                                    explanation
                                    quizOptions {
                                        id
                                        letter
                                        content
                                    }
                                }
                            }
                        }
                        pollAnswerSet {
                            id
                            pollAnswerCount
                            answers {
                                id
                                answers
                                question {
                                    id
                                    number
                                    content
                                    chartType
                                    options {
                                        id
                                        number
                                        content
                                        answerCount
                                    }
                                }
                            }
                        }
                        taskAnswerFile {
                            id
                            logoSrc
                            src
                            name
                        }
                        impactTrackerAnswerSet {
                            id
                            impactLikertAnswers {
                                id
                                statement
                                leftLabel
                                rightLabel
                                value
                            }
                        }
                        selectInImageMedia {
                            id
                            mediaType
                            src
                            name
                            logo
                        }
                        imageSelectionAnswers {
                            id
                            part
                            clickX
                            clickY
                            answerType
                            answer
                            explanation
                        }
                        imageSelectionScore {
                            earnedScore
                            possibleScore
                        }
                    }
                }
            }
        }
        pathGroupForTask(id:$id) {
            id
            members {
                id
                person {
                    id
                    firstName
                    lastName
                    profilePicSrc
                }
            }
        }
    }
`);

// Derived types from the generated document
export type ITask = NonNullable<ResultOf<typeof query>["task"]>;
export type ISubmittedTask = NonNullable<ITask["submittedTask"]>;
export type ITaskVariant = ITask["taskVariants"][number];
export type ISubmittedTaskVariant = NonNullable<ISubmittedTask["submittedTaskVariant"]>;
export type IPathGroup = ResultOf<typeof query>["pathGroupForTask"];
export type ITaskThreadItem = NonNullable<ISubmittedTask["thread"][number]>;
export type ITaskQuestion = ITaskVariant["taskQuestions"][number];
export type IIncompleteAnswer = ITaskVariant["incompleteAnswers"][number];
export type IPerson = NonNullable<NonNullable<ITask["finished"]>[number]>;
export type ITaskApproval = NonNullable<ISubmittedTask["taskApprovals"][number]>;
export type ICollectFeedbackAnswerSet = NonNullable<
    NonNullable<NonNullable<ISubmittedTask["collectFeedback"]>["collectFeedbackAnswerSets"]>[number]
>;
export type ITeamScan = NonNullable<ISubmittedTaskVariant["teamScan"]>;
export type IPulse = NonNullable<ISubmittedTaskVariant["pulse"]>;

// Save incomplete answers mutation

export const saveIncompleteMutation = graphql(`
    mutation AppTaskSaveIncompleteMutation($data: PlayerIncompleteAnswerSaveData!) {
       incompleteAnswerSave(data: $data) {
            error
            incompleteAnswers {
                id
                taskVariant {
                    id
                }
            }
        }
    }
`);

// Approve answer mutation

export const approveTaskMutation = graphql(`
    mutation AppTaskApproveGroupTaskMutation($submittedTaskId: ID!) {
       approveGroupTask(submittedTaskId: $submittedTaskId) {
            error
            status
            redirect
            submittedTask {
                id
            }
        }
    }
`);

// Submit task mutation

export const submitMutation = graphql(`
    mutation AppTaskSubmitTaskMutation($data: PlayerSubmitTaskData!) {
       submitTask(data: $data) {
            error
            redirect
            submittedTask {
                id
            }
        }
    }
`);
